import { render, staticRenderFns } from "./BomTab.vue?vue&type=template&id=27842a75&scoped=true"
import script from "./BomTab.vue?vue&type=script&lang=js"
export * from "./BomTab.vue?vue&type=script&lang=js"
import style0 from "./BomTab.vue?vue&type=style&index=0&id=27842a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27842a75",
  null
  
)

export default component.exports